import { ListHeader } from 'components/molecules/ListHeader';

export const ComponentListHeader = () => (
  <ListHeader
    columns={[
      'コンポーネント名',
      '管理場所',
      'マニフェストファイル名',
      '必要なキー',
    ]}
    templateColumns="1fr 2fr 2fr 3fr"
  />
);
